import Vue from 'vue';
import Router from 'vue-router';
import Main from './modules/Main';
import About from './components/About';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'main',
            component: Main,
            props: route => ({
                hash: route.query.token || route.query.v
            })
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/404',
            name: 'error',
        },
        {
            path: '/500',
            name: 'server-error',
        },
        {
            path: '/index.html',
            redirect: '/',
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.path === '/404') {
        window.location.href = "/watch/404.html";
    } else if (to.path === '/500') {
        window.location.href = "/watch/500.html";
    } else {
        next()
    }
});

export default router;
